<script setup lang="ts"></script>

<template>
    <h1>Произошла ошибка</h1>
</template>

<style scoped></style>
